{
  "aiGeneratedAnswer": "AI Generated Answer",
  "allCategories": "All Categories",
  "appliedFiltersToCurrentSearch": "Applied filters to current search",
  "apply": "Apply",
  "applyFilters": "Apply Filters",
  "autocompleteOptionsFound_one": "{{count}}{{label}} autocomplete option found.",
  "autocompleteOptionsFound_other": "{{count}}{{label}} autocomplete options found.",
  "autocompleteSuggestion": "autocomplete suggestion: {{suggestion}}",
  "autocompleteSuggestionsFound_one": "{{count}} autocomplete suggestion found.",
  "autocompleteSuggestionsFound_other": "{{count}} autocomplete suggestions found.",
  "basedOnYourDevice": " (based on your device)",
  "basedOnYourInternetAddress": " (based on your internet address)",
  "categoriesText_one": "The following category yielded results for - <strong>{{query}}</strong>",
  "categoriesText_other": "The following categories yielded results for - <strong>{{query}}</strong>",
  "clearAll": "Clear All",
  "clearMinAndMax": "Clear min and max",
  "clearTheRangeToSelectOptions": "Clear the range to select options.",
  "clearTheSearchBar": "Clear the search bar",
  "conductASearch": "Conduct a search",
  "currentLocation": "Current Location",
  "didYouMean": "Did you mean <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "When autocomplete results are available, use up and down arrows to review and enter to select.",
  "feedback": "Feedback",
  "filterGroupSearchInputLabel": "Search {{title}} Options",
  "invalidRange": "Invalid range",
  "max": "Max",
  "min": "Min",
  "navigateToTheNextResultsPage": "Navigate to the next results page",
  "navigateToThePreviousResultsPage": "Navigate to the previous results page",
  "noAutocompleteOptionsFound": "0 autocomplete options found.",
  "noAutocompleteSuggestionsFound": "0 autocomplete suggestions found.",
  "noResultsFoundIn": "No results found in {{currentVerticalLabel}}.",
  "paginationPage": "page {{pageNumber}}",
  "pagination": "Pagination",
  "readMoreAbout": "Read more about <a>{{name}}</a>",
  "recentSearch": "recent search: {{query}}",
  "recentSearchesFound_one": "{{count}} recent search found.",
  "recentSearchesFound_other": "{{count}} recent searches found.",
  "removeFilter": "Remove \"{{displayName}}\" filter",
  "resultPreview": "result preview: {{value}}",
  "resultPreviewsFound_one": "{{count}} result preview found.",
  "resultPreviewsFound_other": "{{count}} recent previews found.",
  "resultsCountText_one": "{{count}} Result",
  "resultsCountText_other": "{{count}} Results",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} of {{resultsCount}} Results",
  "searchHere": "Search here...",
  "showingAllInstead": "Showing all {{currentVerticalLabel}} instead.",
  "showLess": "Show Less",
  "showMore": "Show More",
  "sources_one": "Source",
  "sources_other": "Sources ({{count}})",
  "submitSearch": "Submit Search",
  "suggestionResultsCount_one": "{{label}} - {{count}} result",
  "suggestionResultsCount_other": "{{label}} - {{count}} results",
  "thankYouForYourFeedback": "Thank you for your feedback!",
  "thisAnsweredMyQuestion": "This answered my question",
  "thisDidNotAnswerMyQuestion": "This did not answer my question",
  "unselectAnOptionToEnterInARange": "Unselect an option to enter in a range.",
  "updateYourLocation": "Update your location",
  "useCurrentLocation": "Use Current Location",
  "useMyLocation": "Use my location",
  "viewAll": "View all",
  "viewDetails": "View Details"
}
